<!-- This modal is imported into feature-view.vue as a tab. This tab lists all promotion item groups that are currently attached to a feature and allows the user to remove them from the feature -->
<template>
  <v-container class="ma-0 pa-0" fluid v-resize="onResize">
    <v-data-table
      :headers="headers"
      :height="tableHeight"
      :items="orderedItems"
      loading-text="Retrieving Existing Data...Please Wait"
      :search="search"
      :loading="loading"
      :class="table"
      class="rounded-0"
      group-by="promo_item_group.id"
      dense
      fixed-header
      :hide-default-footer="$auth.tenant !== 'alliance-retail-group'"
      item-key="id"
      loader-height="5"
      no-data-text="No Data to Display"
      :items-per-page="$auth.tenant === 'alliance-retail-group' ? -1 : pageSize">

      <!-- <template #top>
        <v-divider/>
        <v-toolbar floating class="fill" flat>
          <v-row align="center">
            <v-col md="3" lg="3">
              <v-text-field :class="body" class="mt-7" label="Filter Items" outlined dense background-color="input"
                prepend-inner-icon="mdi-filter-outline" v-model="search">
              </v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template> -->

      <template v-if="$auth.tenant === 'alliance-retail-group'" #[`group.header`]="{ group, items, headers}">
        <td :colspan="headers.length">
          <v-row align="center">
            <v-col class='truncate'>
              <span>
                <b>Promo Item Group</b><br>
                <div class='truncate'>
                {{items[0].promo_item_group.name}}
                </div>
              </span>
            </v-col>
            <v-col class='truncate'>
              <span>
                <b>Promo Name</b><br>
                {{items[0].promo.name}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Promo Start Date</b><br>
                {{formatDateDisplay(items[0].promo.start_dt)}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Promo End Date</b><br>
                {{formatDateDisplay(items[0].promo.end_dt)}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Billing Mode</b><br>
                {{items[0].promo.billing_mode}}
              </span>
            </v-col>
            <v-col v-if="items[0].promo_item_group.buy_item">
              <span>
                <b>Buy Item?</b><br>
                <v-icon dense>mdi-check-bold</v-icon>
              </span>
            </v-col>
            <v-col v-if="items[0].promo_item_group.get_item">
              <span>
                <b>Get Item?</b><br>
                <v-icon dense>mdi-check-bold</v-icon>
              </span>
            </v-col>
            <v-col v-if="(items[0].promo_item_group.get_item || items[0].promo_item_group.buy_item)">
              <span>
                <b>Qty</b><br>
                {{items[0].promo_item_group.qty}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Promo Type</b><br>
                {{items[0].promo.promotion_type}}
              </span>
            </v-col>
            <v-col align="right">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn small icon v-on="on"
                    class="mr-6"
                    @click="feature.promo_item_group_ids.includes(group) ? handleRemove(items[0]) : linkPromo(items[0])"
                    :color="feature.promo_item_group_ids.includes(group) ? 'red' : 'green'">
                    <v-icon>
                      {{feature.promo_item_group_ids.includes(group) ? 'mdi-trash-can' : 'mdi-plus'}}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{feature.promo_item_group_ids.includes(group) ? 'Remove' : 'Add'}}</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn small icon v-on="on" class="mr-2" @click='openLink(items[0])'>
                    <v-icon>
                      mdi-open-in-new
                    </v-icon>
                  </v-btn>
                </template>
                <span>Promotion Portal</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </td>
      </template>

      <template v-else #[`group.header`]="{ group, items, headers}">
        <td :colspan="headers.length">
          <v-row align="center">
            <v-col class='truncate'>
              <span>
                <b>Promo Item Group</b><br>
                <div class='truncate'>
                {{items[0].promo_item_group.name}}
                </div>
              </span>
            </v-col>
            <v-col class='truncate'>
              <span>
                <b>Promo Name</b><br>
                {{items[0].promo.name}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Promo Type</b><br>
                {{items[0].promo.promotion_type}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Promo Start Date</b><br>
                {{formatDateDisplay(items[0].promo.start_dt)}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Promo End Date</b><br>
                {{formatDateDisplay(items[0].promo.end_dt)}}
              </span>
            </v-col>
            <v-col v-if="items[0].promo_item_group.buy_item">
              <span>
                <b>Buy Item?</b><br>
                <v-icon dense>mdi-check-bold</v-icon>
              </span>
            </v-col>
            <v-col v-if="items[0].promo_item_group.get_item">
              <span>
                <b>Get Item?</b><br>
                <v-icon dense>mdi-check-bold</v-icon>
              </span>
            </v-col>
            <v-col v-if="(items[0].promo_item_group.get_item || items[0].promo_item_group.buy_item)">
              <span>
                <b>Qty</b><br>
                {{items[0].promo_item_group.qty}}
              </span>
            </v-col>
            <v-col>
              <span>
                <b>Billing Mode</b><br>
                {{items[0].promo.billing_mode}}
              </span>
            </v-col>
            
            <v-col align="right">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn small icon v-on="on"
                    class="mr-6"
                    @click="feature.promo_item_group_ids.includes(group) ? handleRemove(items[0]) : linkPromo(items[0])"
                    :color="feature.promo_item_group_ids.includes(group) ? 'red' : 'green'">
                    <v-icon>
                      {{feature.promo_item_group_ids.includes(group) ? 'mdi-trash-can' : 'mdi-plus'}}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{feature.promo_item_group_ids.includes(group) ? 'Remove' : 'Add'}}</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn small icon v-on="on" class="mr-2" @click='openLink(items[0])'>
                    <v-icon>
                      mdi-open-in-new
                    </v-icon>
                  </v-btn>
                </template>
                <span>Promotion Portal</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </td>
      </template>

      <template #[`item.promotion_price`]="{ item }">
        <span v-if="item.promo_item_group.promotion_price">
          ${{formatCurrencyDisplay(item.promo_item_group.promotion_price)}}
        </span>
        <span v-else-if="item.promo.promotion_price">
          ${{formatCurrencyDisplay(item.promo.promotion_price)}}
        </span>
        <span v-else>-</span>
      </template>

      <template #[`item.complex_promo_price`]="{ item }">
        <span v-if="item.promo_item_group.complex_promo_price">
          ${{formatCurrencyDisplay(item.promo_item_group.complex_promo_price)}}
        </span>
        <span v-else-if="item.promo.complex_promo_price">
          ${{formatCurrencyDisplay(item.promo.complex_promo_price)}}
        </span>
        <span v-else>-</span>
      </template>

      <template #[`item.rebate_amount`]="{ item }">
        <span v-if="item.promo_item_group.rebate_amount">
          ${{ formatCurrencyDisplay(item.promo_item_group.rebate_amount) }}
        </span>
        <span v-else-if="item.promo.rebate_amount">
          ${{formatCurrencyDisplay(item.promo.rebate_amount)}}</span>
        <span v-else>-</span>
      </template>

      <template #[`item.billback_allowance`]="{ item }">
        <span v-if="item.accrual_amt">
          ${{formatCurrencyDisplay(item.accrual_amt)}}
        </span>
        <span v-else-if="item.promo_item_group.billback_allowance">
          ${{formatCurrencyDisplay(item.promo_item_group.billback_allowance)}}
        </span>
        <span v-else-if="item.promo.billback_allowance">
          ${{formatCurrencyDisplay(item.promo.billback_allowance)}}
        </span>
        <span v-else>-</span>
      </template>

      <template #[`item.amap_allowance`]="{ item }">
        <span v-if="item.promo_item_group.amap_allowance">
          ${{formatCurrencyDisplay(item.promo_item_group.amap_allowance)}}
        </span>
        <span v-else-if="item.promo.amap_allowance">
          ${{formatCurrencyDisplay(item.promo.amap_allowance)}}
        </span>
        <span v-else>-</span>
      </template>

      <template #[`item.compliance_enforced`]="{ item }">
        <v-icon v-if="item.promo.enforce_compliance" dense>mdi-shield-check-outline</v-icon>
        <span v-else>-</span>
      </template>

      <template #[`item.early_buy_allowance`]="{ item }">
        <span v-if="item.promo_item_group.early_buy_allowance">
          ${{formatCurrencyDisplay(item.promo_item_group.early_buy_allowance)}}
        </span>
        <span v-else-if="item.promo.early_buy_allowance">
          ${{formatCurrencyDisplay(item.promo.early_buy_allowance)}}
        </span>
        <span v-else>-</span>
      </template>

      <template #[`item.retail_price`]="{ item }">
        <span v-if="item.retail_price">
          ${{formatCurrencyDisplay(item.retail_price)}}
        </span>
        <span v-else>-</span>
      </template>

    <template v-slot:[`item.cost`]="{ item }">
        <v-tooltip top v-if="(item.item.future_cost == item.item.cost) && (item.item.future_cost_date <= effectiveFutureCostDate)" >
          <template v-slot:activator="{ on }">
            <span v-on="on" class="primary--text font-weight-bold">
              ${{formatCurrencyDisplay(item.item.cost)}}
            </span>
          </template>
          This item has a cost change on {{$dateConfig.formatDate(item.item.future_cost_date)}} <br>
          The new cost of ${{formatCurrencyDisplay(item.item.cost)}} will be used on this ad
        </v-tooltip>
        <span v-else> ${{formatCurrencyDisplay(item.cost)}} </span>
      </template>

      <template #[`item.item.unit_cost`]="{ item }">
          <span v-if="item.item.qty_per_case">
            ${{formatCurrencyDisplay(calcUnitCost(item))}}
          </span>
          <span v-else> - </span>
        </template>

     <template #[`item.item.gross_profit`]="{ item }">
       <span v-if="$auth.tenant=='awg' && item.promo_item_group.get_item == true && feature.sign_offer_details?.sign_offer_type === 'Buy X Get Y'">0.00%</span>
       <span v-else>{{formatCurrencyDisplay(calcGrossProfit(item))}}%</span>
      </template>

      <template #[`item.start_dt`]="{ item }">
        {{formatDateDisplay(item.start_dt)}}
      </template>

      <template #[`item.end_dt`]="{ item }">
        {{formatDateDisplay(item.end_dt)}}
      </template>
      <template v-if="$auth.tenant !== 'alliance-retail-group'" #footer>
        <PagingFooter
          :pageSize.sync='pageSize'
          :pageSizes='pageSizes'
          :page='page'
          :disablePrevious='disablePrevious'
          :disableNext='disableNext'
          @next='next'
          @previous='previous'
        > 
        <template #footer-button>
          <slot name='footer-button' />
        </template>
      </PagingFooter>
    </template>
    </v-data-table>
    <v-dialog v-if="showRemoveDialog" :value="showRemoveDialog" @click:outside="showRemoveDialog = false; selectedGroup = {}" width="450">
      <v-card>
        <v-card-title>Remove Item Group</v-card-title>
        <v-card-text>
          Remove item group "{{ selectedGroup.promo_item_group.name }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :class="body" text @click="showRemoveDialog = false">Close</v-btn>
          <v-btn :class="body" class="red white--text" @click.stop='unlinkPromo(selectedGroup.promo_item_group.id)'>Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { utils } from '@/mixins/utils'
import { displayHelpers } from '@/mixins/display-helpers'
import { format } from '@/mixins/format'
import { displayAlert } from '@/mixins/alert'
import { paging } from '@/mixins/paging'
import PagingFooter from '@/components/shared/paging-footer.vue'
import {cloneDeep} from 'lodash'
export default {
  name: 'FeaturePromoItems',
  components: {
    PagingFooter
  },
  mixins: [displayHelpers, format, utils, displayAlert, paging],
  props: [
    'selectedAd',
    'feature',
    'showInfo',
    'adParty'
  ],
  data: () => ({
    component: '',
    loading: false,
    modal: false,
    promoInfo: false,
    items: [],
    groupLength: 0,
    selectedGroup: {},
    search: '',
    responsible_party_id: '49b5f50f-6bf8-4315-9366-5d993572277d',
    tableHeight: '',
    offset: true,
    page: 1,
    pageSize: 200,
    pageSizes: [25, 50, 100, 200],
    promoID: [],
    promos:[],
    promoItems:[],
    item_response_count: 0,
    showRemoveDialog: false,
    formatFields: [
      'rebate_amount', 'billback_allowance', 'amap_allowance', 'early_buy_allowance'
    ],
    scanAllowanceFields: ['rebate_amount'],
    billbackAllowanceFields: ['billback_allowance', 'amap_allowance', 'early_buy_allowance']
  }),
  computed: {
    searchParams () {
      return [
        { description: 'Item ID', param: 'item_id' },
        { description: 'UPC', param: 'upc' }
        // { description: 'Vendor Name', param: 'i.vendor_name' },
        // { description: 'Vendor ID', param: 'i.vendor_id' },
        // { description: 'Promo Name', param: 'c.promo.name' },
        // { description: 'Promo Type', param: 'c.promo.promotion_type.name' }
      ]
    },
    disableNext () {
      return this.item_response_count < this.pageSize
    },
    headers () {
      let headers = [
        { sortable: false, filterable: false, class: 'accent white--text', display_order: 0, show: true },
        { text: 'Item', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'item.item_id', display_order: 1, show: true },
        { text: 'GTIN', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'item.gtin', display_order: 2, show: this.$auth.tenant === 'pricechopper' },
        { text: 'Source', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'item.source', display_order: 3, show: true },
        { text: 'Name', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'item.description', display_order: 4, show: true },
        { text: 'Promotion Price', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'promotion_price', display_order: 5, show: true },
        { text: 'Compliance Enforced', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'compliance_enforced', display_order: this.isARG ? 11 : 6, show: this.$auth.tenant === 'awg' },
        { text: 'Complex Promo Price', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'complex_promo_price', display_order: this.isARG ? 12 : 7, show: this.isARG },
        { text: 'Scan Allowance', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'rebate_amount', display_order: this.isARG ? 8 : 8, show: true },
        { text: 'Billback Allowance', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'billback_allowance', display_order: this.isARG ? 7 : 9, show: true },
        { text: 'AMAP Allowance', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'amap_allowance', display_order: this.isARG ? 6 : 10, show: true },
        { text: 'Early Buy Allowance', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'early_buy_allowance', display_order: this.isARG ? 9 : 11, show: true },
        { text: this.isARG ? 'Regular Retail' : 'Retail Price', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'retail_price', display_order: this.isARG ? 10 : 12, show: true },
        { text: 'Case Cost', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'cost', display_order: this.isARG ? 5 : 13, show: true },
        { text: 'Net Unit Cost', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'item.unit_cost', display_order: 14, show: true },
        { text: 'Pack Size', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'item.pack_size', display_order: 15, show: true },
        { text: 'Gross Profit %', groupable: false, align: 'start', sortable: false, class: 'accent white--text', value: 'item.gross_profit', display_order: 16, show: true },
      ]

      if (this.$auth.tenant === 'awg') {
        headers.forEach(header => {
          if (header.value !== 'item.description') {
            header.align = 'center'
          }
        })
      }

      return headers.filter(item => item.show).sort((a, b) => a.display_order - b.display_order)
    },
    lengthRefresh() {
      return (this.feature.promo_item_group_ids.length == this.groupLength)
    },
    isARG () {
      return this.$auth.tenant === 'alliance-retail-group'
    },
    orderedItems () {
      if (!this.isARG) return this.items
      const shipperPalletTerms = ['ship', 'shpr', 'shipper', 'plt', 'pallet']
      const items = cloneDeep(this.items)
      const sortedItems = items.sort((a, b) => {
          const aIsShipperPalletItem = shipperPalletTerms.some(term => a.item.description.toLowerCase().includes(term))
          const bIsShipperPalletItem = shipperPalletTerms.some(term => b.item.description.toLowerCase().includes(term))
          if (aIsShipperPalletItem && !bIsShipperPalletItem) return 1 
          if (!aIsShipperPalletItem && bIsShipperPalletItem) return -1
          if (a.item.item_id === b.item.item_id) return 0
          return a.item.item_id < b.item.item_id ? -1 : 1
        }
      )
      return sortedItems
    },
    groupedItems () {
      if (this.items.length > 0) {
        return Object.groupBy(this.items, (i) => i.item_id)
      }
      return {}
    }
  },
  watch: {
    showInfo: {
      immediate: true,
      handler () {
        if (!this.showInfo) {
          this.tableHeight = window.innerHeight - 265
        } else {
          this.tableHeight = window.innerHeight - 415
        }
      }
    }
  },
  async created () {
    if (!this.showInfo) {
      this.tableHeight = window.innerHeight - 265
    } else {
      this.tableHeight = window.innerHeight - 430
    }
    this.$root.$on('get-items', () => this.loopPromoItemGroups())
    this.loopPromoItemGroups()
    this.groupLength = this.feature.promo_item_group_ids.length
    this.tableChanged = this.tableChange(this.loopPromoItemGroups)
  },
  methods: {
    onResize () {
      this.tableHeight = window.innerHeight - 430
    },
    itemRowBackground (item) {
      return this.btnToggle === 1 && this.searchResults.indexOf(item) % 2 !== 1 ? 'grey lighten-2' : ''
    },
    async loopPromoItemGroups () {
      this.items = []
      this.loading = true
      if (this.feature.promo_item_group_ids.length === 0) {
        this.loading = false;
        this.$emit('items-updated', [])
        return
      }
      try {
        const { data } = await this.$PromoItemGroup.getBatch(this.feature.promo_item_group_ids)
        const promoIds = data.map(promo => promo.promo_id)
        const promoItems = await this.getPromoItems(promoIds)
        this.items = promoItems
        this.$emit('items-updated', this.items)
      } catch (err) {
        if (Array.isArray(err)) {
          return this.handleNotFoundErrors(err)
        }
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    handleNotFoundErrors (errs) {
      const notFoundIds = []
      errs = errs.flatMap(e => {
        const data = e?.reason?.response?.data
        if (data?.tags?.type === 'NotFoundError' && data?.extras?.type === 'PromoItemGroup') {
          notFoundIds.push(data.extras.id)
          this.feature.promo_item_group_ids = this.feature.promo_item_group_ids.filter(id => id !== data.extras.id)
          return []
        }
        return e
      })
      if (notFoundIds.length > 0) {
        const message = `${notFoundIds.length} promo item group(s) linked to this feature could not be found and have been removed. Group id(s): ${notFoundIds.join(', ')}`
        errs.push(new Error(message))
        this.unlinkPromo(notFoundIds.join(','))
      }
      return this.handleError(errs)
    },
    async getPromoItems(promoIds) {
      const { promo_item_group_ids } = this.feature
      let promoItems = []
      if (this.$auth.tenant !== 'alliance-retail-group') {
        const res = await this.$PromoItem.getBatchItemsByPromo(promoIds, promo_item_group_ids, {
          offset: (this.pageSize * (this.page - 1)),
          limit: this.pageSize,
          source: this.adParty.distribution_center
        })
        promoItems = res.data
      } else {
        let offset = 0
        const limit = 500
        const res = await this.$PromoItem.getBatchItemsByPromo(promoIds, promo_item_group_ids, {
          offset: offset,
          limit: limit,
          source: this.adParty.distribution_center
        })
        promoItems = res.data
        if (promoItems.length > 0) {
          offset += limit
          while (offset === promoItems.length) {
            const offsetRes = await this.$PromoItem.getBatchItemsByPromo(promoIds, promo_item_group_ids, {
              offset: offset,
              limit: limit,
              source: this.adParty.distribution_center
            })
            promoItems = promoItems.concat(offsetRes.data)
            offset += limit
          }
        }
      }
      if (promoItems.length > 0) {
        this.item_response_count = promoItems.length
        return this.processPromoItems(promoItems)
      }
      else {
        this.item_response_count = 0
      }
      return []
    },
    processPromoItems(promoItems) {
      const { promo_item_group_ids } = this.feature;
      const promoGroupSeenItems = new Map(); // Map to track seen items per promo group            
      const getPromoGroupKey = (item) => item.promo_item_group.id;

      // Initialize map with empty sets for each promo group
      promoItems.forEach(item => {
        const groupKey = getPromoGroupKey(item);
        if (!promoGroupSeenItems.has(groupKey)) {
          promoGroupSeenItems.set(groupKey, new Set());
        }
      });

      // Split items into sourceItems and isVmcItems
      const sourceItems = promoItems.filter(item => item.item.source === this.adParty.distribution_center);
      const isVmcItems = promoItems.filter(item => item.item.is_vmc === true);

      // Mark sourceItems as seen in their respective promo groups
      sourceItems.forEach(item => {
        const groupKey = getPromoGroupKey(item);
        const seenSet = promoGroupSeenItems.get(groupKey);
        seenSet.add(item.item.item_id);
      });

      // Filter out duplicates from isVmcItems based on the same promo group
      const uniqueIsVmcItems = isVmcItems.filter(item => {
        const groupKey = getPromoGroupKey(item);
        const seenSet = promoGroupSeenItems.get(groupKey);
        if (!seenSet.has(item.item.item_id)) {
          seenSet.add(item.item.item_id);
          return true;
        }
        return false;
      });

      // Combine both arrays
      const combinedItems = [...sourceItems, ...uniqueIsVmcItems];

      // Format and filter the combined items
      return combinedItems.flatMap(item => {
        if (promo_item_group_ids.includes(item.promo_item_group.id)) {
          return this.formatPromoItem(item)
        }
        return []
      })
    },
    formatPromoItem(promoItem) {
      const retail = promoItem.retail_price || promoItem.item.sale_price
      const cost = promoItem.cost || promoItem.item.cost

      promoItem.retail_price = retail
      promoItem.cost = cost
      for (const field of this.formatFields) {
        promoItem[field] = this.getFormattedDisplayValue(promoItem, field)
      }
      promoItem.item_id = promoItem.item.item_id
      promoItem.source = promoItem.item.source
      promoItem.qty_per_case = promoItem.item.qty_per_case
      return promoItem
    },
    getFormattedDisplayValue (promoItem, key) {
      const group = promoItem.promo_item_group
      const promo = promoItem.promo
      let value = promoItem[key] || group[key]
      if (value == null && promo[key]) {
        value = promo[key]
      }
      return value
    },
    calcGrossProfit(item){
      if (this.isARG) {
        return this.calcItemGrossProfit(item)
      }
      const ad_retail = parseFloat(this.feature.ad_retail)
      const ad_count = parseFloat(this.feature.count)
      const billback_allowance = item.accrual_amt ? item.accrual_amt : item.promo_item_group.billback_allowance

      return Math.round(((((ad_retail / ad_count) * item.item.qty_per_case) 
      - (item.cost) + (item.promo_item_group.rebate_amount * item.item.qty_per_case)
      + (billback_allowance) + (item.promo_item_group.early_buy_allowance) + (item.promo_item_group.amap_allowance))
      / ((ad_retail / ad_count) * item.item.qty_per_case)) * 100) 
    },
    async unlinkPromo (id) {
      this.feature.promo_item_group_ids = this._.pull(this.feature.promo_item_group_ids, id)
      this.promos = []
      this.items = []
      this.promoID = []
      this.update('Removed')
      this.selectedGroup = {}
      this.showRemoveDialog = false
    },
    async update (actions) {
      await this.$Features.updateAdFeature(this.feature.id, this.feature)
        .then(() => {
          this.$root.$emit('refresh-search')
          this.$store.dispatch('setSnackbar', { status: 'success', text: `Promotion Item Group ${actions}` })
        }).catch(err => {
          this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to Update Feature due to ${err?.response?.data?.message || err.message}` })
        }).finally(this.loopPromoItemGroups())
    },
    calcItemGrossProfit(item){
      const ad_retail = parseFloat(this.feature.ad_retail)
      const ad_count = parseFloat(this.feature.count)
      const promoPrice = (ad_retail / ad_count)
      const netUnitCost = this.formatCurrencyDisplay(this.calcItemNetUnitCost(item))
      const amount = (promoPrice - netUnitCost) / promoPrice
      return (amount * 100).toFixed(2)
    },
    calcUnitCost(item){
      if (this.isARG) {
        return this.calcItemNetUnitCost(item)
      }

      const scans = this.getNumericPrice(item.rebate_amount) || 0
      const billback = this.getNumericPrice(item.accrual_amt || item.billback_allowance) || 0
      const amap = this.getNumericPrice(item.amap_allowance) || 0
      const earlyBuy = this.getNumericPrice(item.early_buy_allowance) || 0

      return ((item.cost - billback - amap - earlyBuy) / item.item.qty_per_case) - scans
    },
    calcItemNetUnitCost(promoItem) {
      const activeAllowances = this.groupedItems[promoItem.item_id]
      const { sumScans, sumBillbacks } = this.calcSumActiveAllowances(activeAllowances)
      const { cost, qty_per_case } = promoItem
      return this.calcNetUnitCost(cost, qty_per_case, sumScans, sumBillbacks)
    },
    calcSumActiveAllowances (activeAllowances) {
      const sumScans = this.calcTotalSumAllowances(activeAllowances, this.scanAllowanceFields)
      const sumBillbacks = this.calcTotalSumAllowances(activeAllowances, this.billbackAllowanceFields)
      return { sumScans, sumBillbacks }
    },
    calcTotalSumAllowances(allowanceItems, allowanceFields) {
      return allowanceItems.reduce((total, allowanceItem) => {
        const value = this.calcSumAllowances(allowanceItem, allowanceFields)
        return total + value
      }, 0)
    },
    calcSumAllowances (allowanceItem, allowanceFields) {
      return allowanceFields.reduce((total, field) => {
        let value = allowanceItem[field]
        if ((field === 'rebate_amount') && ['Buy X Save $Y', 'Buy X Get Y'].includes(allowanceItem.promo?.promotion_type)) {
          value = 0
        }
        return total + (value ? this.getNumericPrice(value) : 0)
      }, 0)
    },
    calcNetUnitCost (cost, qty_per_case, sumScans, sumBillbacks) {
      let netUnitCost = 0

      if (cost != null && qty_per_case != null) {
        // remove formatting/normalize
        cost = this.getNumericPrice(cost)
        qty_per_case = Number(qty_per_case)

        if (cost > 0 && qty_per_case > 0 && (sumScans + sumBillbacks) >= 0) {
          netUnitCost = ((cost - sumBillbacks) / qty_per_case) - sumScans
          // if calculated value isn't a positive number, set to 0
          if (Math.sign(netUnitCost) !== 1) netUnitCost = 0
        }
      }
      return netUnitCost
    },
    getNumericPrice (value) {
      if (typeof value === 'string' && value.includes('$')) {
        value = value.replace('$', '')
      }
      value = Number(value)
      return Number.isNaN(value) ? 0 : value
    },
    openLink(pig){
      let baseUrl = process.env.VUE_APP_PROMO_PORTAL
      let prefix = this.$auth.tenantURLPrefix
      if (prefix) {
        baseUrl = `${prefix}.${baseUrl}`
      }
      const url = `https://${baseUrl}/promo?id=${pig.promo.id}`
      window.open(url, 'tab')
    },
    handleRemove(group) {
      this.selectedGroup = group
      this.showRemoveDialog = true
    }
  }
}
</script>
<style scoped>
  .active {
    box-shadow: 0px 2px 10px 3px rgba(120,120,120,0.75);
    background: #385F73;
    color: white !important;
  }
  .truncate {
    display:inline;
    width:20px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis
  }
  ::v-deep .wrap-header {
    line-height: 1.5;
  }
</style>